import apiService from './apiService'

export default {
  // Récupérer tous les clients avec filtres
  async getClients(filters = {}) {
    try {
      const queryParams = new URLSearchParams(filters).toString()
      const endpoint = `/clients${queryParams ? `?${queryParams}` : ''}`
      return await apiService.get(endpoint)
    } catch (error) {
      console.error('Error fetching clients:', error)
      throw error
    }
  },

  // Récupérer un client par ID
  async getClientById(id) {
    try {
      return await apiService.get(`/clients/${id}`)
    } catch (error) {
      console.error('Error fetching client:', error)
      throw error
    }
  },

  // Créer un nouveau client
  async createClient(clientData) {
    try {
      return await apiService.post('/clients', clientData)
    } catch (error) {
      console.error('Error creating client:', error)
      throw error
    }
  },

  // Mettre à jour un client
  async updateClient(id, clientData) {
    try {
      return await apiService.put(`/clients/${id}`, clientData)
    } catch (error) {
      console.error('Error updating client:', error)
      throw error
    }
  },

  // Supprimer un client
  async deleteClient(id) {
    try {
      return await apiService.delete(`/clients/${id}`)
    } catch (error) {
      console.error('Error deleting client:', error)
      throw error
    }
  },

  // Rechercher des clients
  async searchClients(query) {
    try {
      return await apiService.get(`/clients/search?q=${encodeURIComponent(query)}`)
    } catch (error) {
      console.error('Error searching clients:', error)
      throw error
    }
  },

  // Obtenir les contrats d'un client
  async getClientContrats(clientId) {
    try {
      return await apiService.get(`/clients/${clientId}/contrats`)
    } catch (error) {
      console.error('Error fetching client contrats:', error)
      throw error
    }
  },

  // Obtenir les factures d'un client
  async getClientFactures(clientId) {
    try {
      return await apiService.get(`/clients/${clientId}/factures`)
    } catch (error) {
      console.error('Error fetching client factures:', error)
      throw error
    }
  },

  // Obtenir les statistiques des clients
  async getClientStats() {
    try {
      return await apiService.get('/clients/stats')
    } catch (error) {
      console.error('Error fetching client stats:', error)
      throw error
    }
  },

  // Vérifier si un CIN/RC existe déjà
  async checkClientExists(identifier, type = 'cin') {
    try {
      return await apiService.get(`/clients/check-exists?${type}=${encodeURIComponent(identifier)}`)
    } catch (error) {
      console.error('Error checking client exists:', error)
      throw error
    }
  },

  // Obtenir les clients physiques
  async getClientsPhysiques() {
    try {
      return await apiService.get('/clients/physiques')
    } catch (error) {
      console.error('Error fetching clients physiques:', error)
      throw error
    }
  },

  // Obtenir les clients moraux
  async getClientsMoraux() {
    try {
      return await apiService.get('/clients/moraux')
    } catch (error) {
      console.error('Error fetching clients moraux:', error)
      throw error
    }
  }
} 